import { cn } from '@/utils/cn'

export function Badge({ 
  children, 
  className = '', 
  variant = 'default',
  size = 'default',
  ...props 
}) {
  const variants = {
    default: 'bg-primary text-primary-foreground',
    secondary: 'bg-secondary text-secondary-foreground',
    success: 'bg-success-100 text-success-600 dark:bg-success-500/20 dark:text-success-400',
    warning: 'bg-warning-100 text-warning-600 dark:bg-warning-500/20 dark:text-warning-400',
    danger: 'bg-danger-100 text-danger-600 dark:bg-danger-500/20 dark:text-danger-400',
    outline: 'border border-input bg-background',
  }

  const sizes = {
    default: 'px-2.5 py-0.5 text-xs',
    sm: 'px-2 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}